import { type VariantProps, tv } from 'tailwind-variants';

import { Container } from '../../../atoms';
import type { CommonProps } from '../../../types';
import { HeadingLayout } from '../../../organisms';
import { ReactNode, type JSX } from 'react';

export interface EventCompactCardListProps
    extends CommonProps,
        VariantProps<typeof EventCompactCardListStyles> {
    children: ReactNode;
}

export const EventCompactCardListStyles = tv({
    slots: {
        list: 'flex flex-col flex-wrap gap-5',
        container: 'p-0',
    },
});

export const EventCompactCardList = ({
    className,
    children,
    testId = 'compact-event-card-list',
}: EventCompactCardListProps): JSX.Element => {
    const { list, container } = EventCompactCardListStyles();

    return (
        <HeadingLayout className={className} data-testid={testId}>
            <Container className={container()} maxWidth="lg">
                <ul className={list()}>{children}</ul>
            </Container>
        </HeadingLayout>
    );
};
